<template>
  <v-card
    tile
  >
    <v-form
      @submit.prevent="submit"
    >
      <v-card-title
        class="headline primary white--text"
      >
        Ilmianna julkaisu

        <v-btn
          icon
          dark
          absolute
          top
          right
          @click="closeDialog"
          :disabled="$wait.is('reporting reportable')"
        >
          <v-icon>
            close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-card-subtitle class="pl-0">
          Miksi haluat ilmiantaa julkaisun?
        </v-card-subtitle>

        <v-radio-group
          v-model="selectedReason"
          class="mt-0"
        >
          <v-radio
            v-for="(val, key) in reasons"
            :key="key"
            :label="val.fi"
            :value="key"
          />
        </v-radio-group>
      </v-card-text>

      <v-card-actions
        class="d-flex flex-column"
      >
        <v-btn
          :disabled="$wait.is('reporting reportable') || !formReady"
          :loading="$wait.is('reporting reportable')"
          block
          large
          depressed
          style="height: 48px;"
          color="primary"
          type="submit"
        >
          Lähetä
        </v-btn>

        <v-btn
          :disabled="$wait.is('reporting reportable')"
          text
          block
          class="ml-0 mt-2"
          @click="closeDialog"
        >
          Peruuta
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import { mapGetters, mapActions } from 'vuex';
import { reportingReasons } from '@/constants/reportingReasons';

export default {
  computed: {
    ...mapGetters({
      dialogProps: 'dialog/dialogProps',
    }),

    record() {
      return this.dialogProps.record;
    },

    formReady() {
      return this.selectedReason;
    },

    reasons() {
      const reasons = {};

      Object.keys(reportingReasons).forEach((key) => {
        if (reportingReasons[key].show) {
          reasons[key] = reportingReasons[key];
        }
      });

      return reasons;
    },
  },

  data: () => ({
    selectedReason: null,
  }),

  methods: {
    ...mapActions({
      closeDialog: 'dialog/closeDialog',
    }),

    ...mapWaitingActions('reportables', {
      reportRecord: 'reporting reportable',
    }),

    async submit() {
      await this.reportRecord({
        reportable: this.record,
        payload: {
          record: {
            reason: this.selectedReason,
          },
        },
      });

      this.closeDialog();
    },
  },
};
</script>
